import router from '@/router'
import Api from '@/services/api'
import axios from 'axios'
import Pusher from 'pusher-js'
import { ToastProgrammatic as Toast } from 'buefy'
import { homeRouteFor } from '@/constants/permissions'

export function getUserData({ commit }, force) {
	let user = localStorage.getItem('@stup:user')
	let token = localStorage.getItem('@stup:token')

	if (token) {
		if (!user || force) {
			Api.get('/auth/profile').then(({ data }) => {
				commit('setUser', data)
			})
		} else {
			commit('setUser', JSON.parse(user))
		}
	}
}

export function deleteUserData(context) {
	localStorage.removeItem('@stup:token')
	localStorage.removeItem('@stup:user')
	localStorage.removeItem('@stup:city')
	localStorage.removeItem('@stup:temperature')
	localStorage.removeItem('@stup:birthday')

	context.commit('setPermissions', null)
	context.commit('setUser', null)
}

export function getNotifications(context) {
	Api.get('notification/findAll').then(({ data }) => {
		context.commit('setNotifications', data)
		context.commit('setTotalNotifications', data.map(n => n.pivot.read == 0).length)
	})
}

export function subscribeNotification({ commit, dispatch, getters }) {
	if (!getters.notificationStart) {
		if (process.env.VUE_APP_PUSHER_APP_KEY !== '') {
			const pusher = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
				cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER
			})

			const channel = pusher.subscribe('notification')

			channel.bind('notification', () => {
				dispatch('getNotifications')
			})

			pusher.connection.bind('state_change', states => {
				if (states.current == 'connected') {
					dispatch('getNotifications')
					commit('setNotificationStart', true)
				}
			})
		}
	}
}

export function checkUserByToken(context) {
	let uri = window.location.search.substring(1)
	let params = new URLSearchParams(uri)

	if (params.get('token')) {
		const token = params.get('token')

		context.commit('setLoadingRedirect', true)

		const config = {
			headers: { Authorization: `Bearer ${token}` }
		}

		axios
			.get(`${process.env.VUE_APP_BASE_API}user/me`, config)
			.then(({ data }) => {
				localStorage.setItem('@stup:token', token)
				context.commit('setPermissions', JSON.parse(data.permission.route))
				context.commit('setUser', data)

				router.push(homeRouteFor(data.permission_id))
			})
			.catch(() => {
				localStorage.removeItem('@stup:token')
				context.commit('setPermissions', null)
				context.commit('setUser', null)

				Toast.open({
					message: 'Dados inválidos',
					type: 'is-danger',
					position: 'is-bottom'
				})
			})
			.then(() => {
				context.commit('setLoadingRedirect', false)
			})
	} else {
		context.commit('setLoadingRedirect', false)
	}
}
